import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { HarvestEventsProps } from 'services/harvestEvents/types';

// Global Selectors
import { makeSelectHarvestEventQuantitySchedulesSummary } from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    quantitySchedulesSummary?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventQuantitySchedulesSummaryValue extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { quantitySchedulesSummary } = this.props;
        if (!quantitySchedulesSummary) {
            return null;
        }
        return quantitySchedulesSummary;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    quantitySchedulesSummary: makeSelectHarvestEventQuantitySchedulesSummary()
});

export default connect(mapStateToProps)(
    HarvestEventQuantitySchedulesSummaryValue
);
